import React, { PropsWithChildren } from "react";
import { useRouter } from "next/router";

import { Footer } from "../footer/footer";
import { Header } from "../header/header";
import { MainLayout } from "./layout.styles";
import { AppBanner } from "components/app-banner/app-banner";
import { constants } from "constants/constants";
import { OdooLiveChatIdentify } from "components/odoo-live-chat/odoo-live-chat-identify";
import { OdooLiveChatLauncher } from "components/odoo-live-chat/odoo-live-chat-launcher";
import { useAuth } from "stores/auth/auth-context";

const { WEB_CHECKOUT_PATHS } = constants;

interface ILayoutProps {
  pageProps: Record<string, string | number | Record<string, unknown>>;
}

const Layout: React.FC<PropsWithChildren<ILayoutProps>> = ({
  children,
  pageProps
}) => {
  const router = useRouter();
  const { user } = useAuth();
  const isContactMePage = router.pathname.includes("/contact-me");
  const isBimbelPage = router.pathname.includes("/bimbel");
  const isLoggedIn = user?.isUserLoggedIn || false;

  const isPaymentPage = router.pathname.startsWith("/payment/");
  const hideMenu =
    WEB_CHECKOUT_PATHS.includes(router.pathname) ||
    isContactMePage ||
    isPaymentPage;
  const routerQueryLength = Object.keys(router.query).length;
  const hideHeader =
    isPaymentPage ||
    isContactMePage ||
    (hideMenu &&
      (routerQueryLength === 0 || routerQueryLength === 1) &&
      !(
        router.pathname.includes("/paket") ||
        router.pathname.includes("/payment") ||
        router.pathname.includes("/slot-selection")
      ));
  const hideFooter =
    isPaymentPage ||
    router.pathname.includes("/slot-selection") ||
    router.pathname.includes("/latihan/session") ||
    router.pathname.includes("/latihan/history");

  return (
    <>
      <OdooLiveChatIdentify />
      {isLoggedIn && (
        <OdooLiveChatLauncher
          key={router.pathname}
          isBimbelPage={isBimbelPage}
        />
      )}
      <MainLayout>
        <AppBanner pathName={router.pathname} />
        {!hideHeader && <Header hidesMenu={hideMenu} pageProps={pageProps} />}
        {children}
        {hideMenu || hideFooter ? null : <Footer />}
      </MainLayout>
    </>
  );
};

export { Layout };
